export interface Sim {
  nuuma: string;
  password: string;
  documentNumber: string;
}

export enum SfmcDeeplinks {
  TE_CUIDAMOS = 'tecuidamos/tc-raffle-list',
  MULTIMAP = 'multimap',
  FAMILIES = 'families',
  ICT_PRICING = 'client-area/ict-pricing',
}

export interface Deeplink {
  value: string;
  navParams?: any;
  linkRouterParams?: any;
  isModal?: boolean;
}

export function formatNotificationDeeplink(deeplink: Deeplink) {
  return {
    ...deeplink,
    value: deeplink.value?.replace('mets://', '')
  } as Deeplink;
}

export function isValidDeeplink(deeplink: Deeplink) {
  return !!deeplink?.value;
}

export function isSfmcDeeplinkEnabled(deeplink: Deeplink) {
  return Object.values(SfmcDeeplinks).includes(deeplink.value as SfmcDeeplinks);
}

export function isGenericHttpsOpenDirectLink(deeplink: Deeplink) {
  const url = deeplink.value;
  return (url || '').startsWith('https://');
}